export default {
    data (){
        return {
            selectionRowMap: {}
        }
    },

    computed: {
        selectRowNum (){
            return Object.keys(this.selectionRowMap).filter(id => !!this.selectionRowMap[id]).length;
        },

        selectRows (){
            return Object.keys(this.selectionRowMap).reduce((result, key) => {
                let item = this.selectionRowMap[key];

                if(item){
                    result.push(item);
                }

                return result;
            }, []);
        }
    },

    methods: {
        afterInitPageInfo (){
            let tableInstance = this.$getRef(this.tableRef);
            if(tableInstance){
                Object.keys(this.selectionRowMap).filter(id => !!this.selectionRowMap[id]).forEach(id => {
                    this.page.list.filter(ni => ni.id+'' === id+'').forEach(ni => {
                        tableInstance.toggleRowSelection(ni, true);
                    });
                });
            }
        },

        handleSelection(selectionRows, row) {
            if(selectionRows.length === 0){
                (this.page.list || []).forEach(item => {
                    this.$set(this.selectionRowMap, item.id, undefined);
                });
            }else{
                selectionRows.forEach(item => {
                    this.$set(this.selectionRowMap, item.id, item);
                });

                if(!!row){
                    if(selectionRows.filter(item => item.id === row.id).length === 0){
                        this.$set(this.selectionRowMap, row.id, undefined);
                    }
                }
            }
        },

        clearSelection (isConfirm = true){
            function clearFunc() {
                this.$set(this, 'selectionRowMap', {});

                let tableInstance = this.$getRef(this.tableRef);

                tableInstance && tableInstance.clearSelection && tableInstance.clearSelection();
            }

            isConfirm ? this.$isOk('清空确认', '是否要清空勾选项？').then(clearFunc.bind(this)) : clearFunc.call(this);
        }
    }
}



// WEBPACK FOOTER //
// ./src/configure/warp/support/selection.js